import '../styles/Empresas.css';
import Navbar from '../componentes/Navbar';
import PantallaRegistro from '../componentes/PantallaRegistro';
function Registro() {

  return (
    <div className='empresas'>
      <Navbar />
      <PantallaRegistro />
    </div>
  );
}

export default Registro;